export default "/images/7e8af81171cd8be9a5337ef266640616.png";